import React from "react";
import { createPortal } from "react-dom";

/**
 * Renders children into document.body so position:fixed overlays center on the
 * viewport. In-tree overlays under .expandPlayground (position:relative; z-index:0)
 * are trapped in that stacking context and appear misaligned vs the sidebar.
 */
function PortalOverlay({ children }: { children: React.ReactNode }) {
  if (typeof document === "undefined") {
    return <>{children}</>;
  }
  return createPortal(children, document.body);
}

export default PortalOverlay;
